// extracted by mini-css-extract-plugin
export default {"recos":"M4-z","productCardOverride":"N4-z","rowHasBadge":"O4-z"};